"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventSchema = exports.eventInitalized = void 0;
const joi_1 = __importDefault(require("joi"));
const joiMessages_1 = require("../data/joiMessages");
const validations_1 = require("../data/validations");
exports.eventInitalized = {
    name: '',
    description: '',
    nameis: '',
    descriptionis: '',
    from: '',
    to: '',
    fee: '',
    payLink: '',
    imageLink: null,
    image: null,
    mondayRepeat: false,
    tuesdayRepeat: false,
    wednesdayRepeat: false,
    thursdayRepeat: false,
    fridayRepeat: false,
    saturdayRepeat: false,
    sundayRepeat: false,
};
// -- SCHEMAS -- //
exports.eventSchema = joi_1.default.object({
    name: joi_1.default.string().max(50).required().messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Name (English)', isRequired: true }),
    }),
    nameis: joi_1.default.string().max(50).optional().allow('').messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Name (Icelandic)', isRequired: true }),
    }),
    description: joi_1.default.string().required().max(1500).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Description (English)' }),
    }),
    descriptionis: joi_1.default.string().optional().allow('').max(1500).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Name (Icelandic)' }),
    }),
    from: joi_1.default.alternatives().try(joi_1.default.string().allow(''), joi_1.default.string().pattern(validations_1.militaryTimeRegex).min(3).max(5)).optional().messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'From', patternText: 'has to be on the form "hh:mm" such as 13:05' }),
    }),
    to: joi_1.default.alternatives().try(joi_1.default.string().allow(''), joi_1.default.string().pattern(validations_1.militaryTimeRegex).min(3).max(5)).optional().messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'To', patternText: 'has to be on the form "hh:mm" such as 13:05' }),
    }),
    fee: joi_1.default.number().optional().allow('').min(0).max(10000).messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Fee / Price' }),
    }),
    payLink: joi_1.default.string()
        // .pattern(getLinkRegexExpression())
        .allow('')
        .min(7)
        .max(3000)
        .messages({
        ...(0, joiMessages_1.joiStringMessage)({ name: 'Buy link', patternText: 'must be an valid link.' }),
    }),
    imageLink: joi_1.default.any().optional(),
    image: joi_1.default.any().optional(),
    mondayRepeat: joi_1.default.boolean().optional(),
    tuesdayRepeat: joi_1.default.boolean().optional(),
    wednesdayRepeat: joi_1.default.boolean().optional(),
    thursdayRepeat: joi_1.default.boolean().optional(),
    fridayRepeat: joi_1.default.boolean().optional(),
    saturdayRepeat: joi_1.default.boolean().optional(),
    sundayRepeat: joi_1.default.boolean().optional(),
});
